import { TextFilterProps } from '@progress/kendo-react-data-tools'
import { useAppSelector } from 'store'

import { SelectFilter } from '../SelectFilter'

export const TransactionStatusFilter: React.FC<TextFilterProps> = (props) => {
  const { filter, onFilterChange } = props

  const transactionStatus = useAppSelector((state) => state.transactions.status)

  const data = transactionStatus.map((x) => ({ id: x.id, label: x.name, value: x.id }))

  return <SelectFilter filter={filter} onFilterChange={onFilterChange} data={data} />
}
